export default {
  namespaced: true,
  teams: {
    title: "Area",
    name: "Name",
    description: " description",
  },
};
